<template>
  <v-container style="min-height: 700px; background-color: white" class="rounded-lg gradient">
    <v-row>
      <v-col cols="12" md="2">
        <v-banner color="purple" dark shaped height="50px" width="220px">
          <h2>REGISTRATION</h2>
        </v-banner>
      </v-col>
    </v-row>
    <br>
    <ul style="font-weight: 500; color: #0d47a1; font-size: 17px">
      <li>All registrations are non-refundable.</li>
      <li>One registration (physical or online) can only register one accepted paper.</li>
      <li>Papers that are not registered will <span style="font-weight: bolder">not</span> be included in the conference
        proceedings.
      </li>
    </ul>

    <v-row justify="center" style="width: 100%">
      <el-table
          :data="tableData"
          :span-method="objectSpanMethod"
          stripe
          style="max-width: 80%"
          :header-cell-style="{background: '#0d47a1f0', color: '#ffffff'}"
          :row-style="{background: '#58B2F230', color: 'black', }"
          size="medium"
          class="rounded-lg my-7">
        <el-table-column
            prop="p"
            label="Participant">
        </el-table-column>
        <el-table-column
            prop="mem"
            label="Membership">
        </el-table-column>
        <el-table-column
            prop="fee"
            label="Fee">
        </el-table-column>
      </el-table>
    </v-row>

    <p>
      Authors can pay either through EDAS in US$ or by scanning the following QR code in RMB. For attendees from China,
      the QR code option provides Chinese invoices (Fapiao).
    </p>
    <v-row style="width: 100%;" align="center" justify="center" >
      <img src="../assets/qrcode.jpg" alt="QRcode" style="width: 200px">
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "Registration",
  data() {
    return {
      tableData: [{
        p: 'Physical Participant',
        mem: 'IEEE member',
        fee: 'RMB 2200 or US$ 330',
      }, {
        p: 'Physical Participant',
        mem: 'Non-IEEE member',
        fee: 'RMB 2500 or US$ 380',
      }, {
        p: 'Online Participant',
        mem: 'IEEE member',
        fee: 'RMB 2000 or US$ 300',
      }, {
        p: 'Online Participant',
        mem: 'Non-IEEE member',
        fee: 'RMB 2300 or US$ 350',
      },
      ]
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
